/* Haavi product card — <ho-product-card>.
   Variant chips select a variant (updates price + add button); "Add to Cart" adds via AJAX and
   reuses Horizon's cart system: dispatches the Shopify standard CartLinesUpdateEvent (so the header
   count updates, the cart drawer morphs, and it auto-opens), with a resilient fallback if the
   @shopify/events module isn't available. Wishlist is a lightweight localStorage toggle. */
if (!customElements.get('ho-product-card')) {
  customElements.define('ho-product-card', class extends HTMLElement {
    connectedCallback() {
      this.addBtn = this.querySelector('[data-add-btn]');
      this.priceTarget = this.querySelector('[data-price-target]');
      this.selectedId = this.addBtn ? this.addBtn.dataset.variantId : null;

      this.querySelectorAll('.ho-pc__vchip').forEach((chip) => {
        chip.addEventListener('click', () => {
          if (chip.hasAttribute('data-unavailable')) return;
          this.querySelectorAll('.ho-pc__vchip').forEach((c) => { c.classList.remove('is-active'); c.setAttribute('aria-pressed', 'false'); });
          chip.classList.add('is-active');
          chip.setAttribute('aria-pressed', 'true');
          this.selectedId = chip.dataset.variantId;
          if (this.priceTarget && chip.dataset.price) this.priceTarget.textContent = chip.dataset.price;
          if (this.addBtn) { this.addBtn.dataset.variantId = this.selectedId; this.addBtn.disabled = false; }
        });
      });

      const wish = this.querySelector('.ho-pc__wish');
      if (wish) {
        const key = 'ho-wish:' + (this.dataset.productHandle || this.selectedId || '');
        try { if (localStorage.getItem(key) === '1') wish.setAttribute('aria-pressed', 'true'); } catch (e) {}
        wish.addEventListener('click', () => {
          const on = wish.getAttribute('aria-pressed') === 'true';
          wish.setAttribute('aria-pressed', on ? 'false' : 'true');
          try { on ? localStorage.removeItem(key) : localStorage.setItem(key, '1'); } catch (e) {}
        });
      }

      if (this.addBtn) this.addBtn.addEventListener('click', () => this._add());
    }

    async _add() {
      const id = (this.addBtn && this.addBtn.dataset.variantId) || this.selectedId;
      if (!id || this.addBtn.disabled) return;
      const label = this.addBtn.querySelector('[data-add-label]');
      const prev = label ? label.textContent : '';
      this.addBtn.setAttribute('aria-busy', 'true');
      this.addBtn.disabled = true;
      if (label) label.textContent = 'Adding';

      const addUrl = this.dataset.addUrl || '/cart/add';
      const jsUrl = addUrl.endsWith('.js') ? addUrl : addUrl + '.js';
      const cartUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
      const drawerSection =
        (document.querySelector('cart-items-component[data-section-id]') || {}).dataset?.sectionId || 'cart-drawer-section';

      let Events = null;
      try { Events = await import('@shopify/events'); } catch (e) { Events = null; }

      let deferred = null;
      try {
        if (Events && Events.CartLinesUpdateEvent) {
          deferred = Events.CartLinesUpdateEvent.createPromise();
          this.dispatchEvent(new Events.CartLinesUpdateEvent({
            action: 'add', context: 'product',
            lines: [{ merchandiseId: String(id), quantity: 1 }],
            promise: deferred.promise,
          }));
        }

        const body = new FormData();
        body.set('id', String(id));
        body.set('quantity', '1');
        body.set('sections', drawerSection);

        const res = await fetch(jsUrl, { method: 'POST', headers: { Accept: 'text/html' }, body, credentials: 'same-origin' });
        const added = await res.json();
        if (added.status) throw new Error(added.message || 'Add failed');

        if (deferred) {
          const cartJson = await fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => r.json());
          deferred.resolve({
            cart: Events.CartLinesUpdateEvent.createCartFromAjaxResponse(cartJson),
            detail: { items: cartJson.items, sections: added.sections, itemCount: 1, source: 'ho-product-card', didError: false },
          });
        }

        // Open Haavi's custom cart drawer (assets/ho-cart-drawer.js listens for 'cart:added',
        // then refreshes its contents from the Section Rendering API and slides open).
        if (document.querySelector('[data-cart-drawer]')) {
          document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: { source: 'ho-product-card' } }));
        } else {
          window.location = cartUrl;
        }

        if (label) label.textContent = 'Added';
        setTimeout(() => { if (label) label.textContent = prev; }, 1600);
      } catch (err) {
        if (deferred) { try { deferred.resolve({ cart: null, detail: { source: 'ho-product-card', didError: true } }); } catch (e) {} }
        console.warn('[ho-product-card] add to cart failed', err);
        if (label) label.textContent = 'Try again';
        setTimeout(() => { if (label) label.textContent = prev; }, 1800);
      } finally {
        this.addBtn.removeAttribute('aria-busy');
        this.addBtn.disabled = false;
      }
    }
  });
}
